export const getProjectTasksQueryKey = ([, projectId])=>[
        'tasks',
        projectId
    ];
export const getProjectDetailQueryKey = (projectId)=>{
    return projectId;
};
export const getProjectSprintsQueryKey = ([, projectId])=>[
        'sprints',
        projectId
    ];
export const getSprintsForProject = ([, projectId])=>[
        'sprints-drpdown',
        projectId[1]
    ];
export const getProjectUsersLiteKey = (projectId)=>{
    var _ref;
    return [
        'project-users-lite',
        `${(_ref = projectId === null || projectId === void 0 ? void 0 : projectId.toString()) !== null && _ref !== void 0 ? _ref : 'all'}`
    ];
};
export const getProjectDependencyMapKey = (projectId)=>[
        'project-dependency-map',
        `${projectId.toString()}`
    ];
